<template>
  <div class="rev_form">
    <button class="showForm def-bt" @click="showPopUp">{{params.messages.btnText}}</button>
    <div class="modal fade mid-modal show" style="display: block;padding-right: 17px;" v-if="openPopUp">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <button type="button" class="close" @click="closeModal"></button>

          <div class="modal-res">
            <div class="modal-tit">{{params.messages.btnText}}</div>
            <div class="modal-in">
              <div class="row">
                <div class="col-md-6" >
                  <div class="trew_text" v-html="params.messages.text"></div>
                </div>
                <div class="col-md-6">
                  <div class="trew_text">
                    <div class="auth_inform" v-if="!params.show" v-html="params.messages.authText"></div>
                    <div v-else>
                      <form @submit.prevent="addReview" v-if="!success">
                        <input type="hidden" v-for="field in params.hidden" :name="field.name" :value="field.value">
                        <div class="row">
                          <div class="col-md-12 errors" v-if="errors.length>0">
                            <div v-for="error in errors">{{error}}</div>
                          </div>
                          <div class="col-md-6">
                            <div class="field">
                              <div class="title_field">
                                {{params.messages.fieldNAME}}
                              </div>
                              <div class="field_wrap">
                                <input type="text" name="name" value="">
                              </div>
                            </div>
                            <div class="field">
                              <div class="title_field">
                                {{params.messages.fieldEMAIL}}
                              </div>
                              <div class="field_wrap">
                                <input type="text" name="email" value="">
                              </div>
                            </div>
                            <div class="field">
                              <div class="title_field">
                                {{params.messages.fieldRATING}}
                              </div>
                              <div class="field_wrap">
                                <span class="star" v-for="index in 5" @click="setRating(index)" :class="(index)<=rating?'active':''">★</span>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="field">
                              <div class="title_field">
                                {{params.messages.fieldREVIEW}}
                              </div>
                              <div class="field_wrap">
                                <textarea name="text"></textarea>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="field t-a-c">
                              <div class="field_wrap">
                                <button class="save def-bt">{{params.messages.btnText}}</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                      <div v-else class="success">
                        {{params.messages.confirmText}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "shops_detail_reviewform",
  selector: '.shops_detail_reviewform',
  props:{params: Object},
  data() {
    return {
      openPopUp:false,
      body:false,
      errors:[],
      rating:5,
      loading:false,
      success:false
    };
  },
  methods: {
    showPopUp() {
      this.openPopUp = true;
      this.body.addClass("modal-open");
      this.body.css("padding-right", "17px");
    },
    closeModal() {
      this.openPopUp = false;
      this.body.removeClass("modal-open");
      this.body.css("padding-right", "");
    },
    setRating(newR) {
      this.rating = newR;
    },
    async addReview(event) {
      let data = new FormData(event.target);
      data.append("rating",this.rating);

      if(!this.loading) {
        this.loading = true;
        const res = await axios.post(this.params.action, data);
      if(res.data[this.params.templateId].errors) {
        this.errors = res.data[this.params.templateId].errors;
      } else if(res.data[this.params.templateId].success){
        this.errors = [];
        this.success = true;
      }
        console.log(res.data[this.params.templateId]);
        this.loading = false;
      }
      return false;
    }
  },
  mounted() {
    this.body = $("body");
  }
}
</script>

<style scoped>
  .rev_form {
    text-align: center;
  }
  .showForm.def-bt,.save.def-bt {
    display: inline-block;
  }
  .showForm.def-bt {
margin-bottom: 20px;
  }
  .modal-tit {
    font-size: 20px;
    font-family: 'Montserrat', sans-serif;
    padding: 40px 15px 5px;
    width: 100%;
    text-align: center;
    font-weight: 600;
    letter-spacing: 3px;
  }
  .modal-in {
    width: 100%;
    margin-bottom: 20px;
    text-align: left;
  }
  .trew_text {
    padding: 20px;

  }
  .mid-modal.show {
    background: #00000036;
  }
  .rev_form input {
    height: 35px;
    padding: 0 8px;
    font-size: 14px;
  }
  .rev_form textarea
  {
    font-size: 14px;
    border-radius: 9px;
    width: 100%;
    height: 170px;
    padding: 8px;
  }


  .field {
    margin-bottom: 10px;
  }
  .star
  {
    font-size: 32px;
    color: #aaa;
    cursor: pointer;
    /*-webkit-text-stroke-width: 2px;*/
    /*-webkit-text-stroke-color: black;*/
  }
  .star.active
  {
    color: #eec7c3;
  }
  .t-a-c {
    text-align: center;
  }
  .errors {
    color: red;
  }
.success {
  color: #399a09;
}


</style>